export default __webpack_public_path__ + "static/media/Group_new.286b06bc.svg";